import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=f60a3cf4&scoped=true"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=f60a3cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60a3cf4",
  null
  
)

export default component.exports